// What a terminal does with files, in a popover from a page's head (RFC-054,
// byj-1wv.51.20): /files' with every line, a file's page with its own file's.
import { putCommand } from "../files";
import { t } from "../i18n";
import { AuthorCommands } from "./CommandLine";
import { Popover } from "./Popover";

/** What a terminal does with files, as a line saying what and the command: put, its next version, a hand-in, get. */
export const terminalLines = (): [string, string][] => [
  [t("files:fileTerminalPut"), putCommand],
  [t("files:fileTerminalNext"), t("files:fileNextCommand", { id: "ID" })],
  [t("files:fileTerminalHandIn"), t("files:handInByTerminal", { code: "CODE", key: "KEY" })],
  [t("files:fileTerminalGet"), t("files:fileGetCommand", { id: "ID" })],
];

/**
 * What a terminal does with files, each line said and its command to copy
 * (AuthorCommands), and what a folder is put without — in a popover from a
 * page's head, as /templates says how one is published: /files' with every
 * line, a file's page with its own file's.
 */
export function TerminalCommands({ lines = terminalLines(), label = t("files:fileFromTerminal") }: { lines?: [string, string][]; label?: string }) {
  return (
    <Popover label={t("files:fileTerminalTitle")} button={label} buttonClassName="small" className="pop" popClassName="pop-panel file-terminal-pop" focus="button">
      {() => (
        <div className="stack tight" data-testid="file-terminal">
          {lines.map(([what, cmd]) => (
            <div key={cmd}>
              <p className="muted small flush">{what}</p>
              <AuthorCommands commands={[cmd]} />
            </div>
          ))}
          <p className="muted small flush">{t("files:fileTerminalLeftOut")}</p>
        </div>
      )}
    </Popover>
  );
}
